import { ChainActions, ChainActionTypes } from "actions";
import { IChain } from "sagas/chainSaga";

interface ChainState {
  chain: IChain;
  loading: boolean;
  error: string | null;
}

const initialState: ChainState = {
  chain: {
    block_height: 0,
    current_epoch: 0,
    absolute_slot: 0,
    transaction_count: 0,
  },
  loading: false,
  error: null,
};

const chainReducer = (
  state = initialState,
  action: ChainActions
): ChainState => {
  switch (action.type) {
    case ChainActionTypes.FETCH_CHAIN_REQUEST:
      return { ...state, loading: true, error: null };
    case ChainActionTypes.FETCH_CHAIN_SUCCESS:
      return { ...state, loading: false, chain: action.payload };
    case ChainActionTypes.FETCH_CHAIN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default chainReducer;
